import React, { Component } from 'react';
import {
  Text,
  View,
  TextInput,
  Dimensions,
  TouchableHighlight,
  Image
} from 'react-native';
import {StyleContext} from '../styleC';
import info from '../info';
import MavTextInput from './mavTextInput';

export default class MavButton extends Component {
constructor(props) { 
    super(props);






    
    this.state = {
      test:false,
      

    }
  }




  render() {
    return (
    <StyleContext.Consumer>{style => 
    <View style={(this.props.style==undefined)?{}:this.props.style}>
      <View style={{backgroundColor:style.backgroundColorContrast,minHeight:20,marginLeft:(Dimensions.get('window').width>style.mobileSizeMax)?style.minimizeMarginLeft:Dimensions.get('window').width*0.1, marginRight:(Dimensions.get('window').width>style.mobileSizeMax)?style.minimizeMarginLeft:Dimensions.get('window').width*0.1, shadowOpacity: 0.3,shadowRadius:2,shadowOffset: {height: 0,width: 0},elevation:1 }}> 
      <View style={{flexDirection:"row", alignItems:"center",marginTop:4, marginBottom:(this.props.miniLine==true)?6:undefined, }}>
        {this.props.type=="warning" && <Image source={require("../assets/warning.png") } style={{width:20,height:20,marginRight:2,marginLeft:4,}}></Image>}
        {this.props.type=="info"  && <Image source={(style.mode=="dark")?require('../assets/iconiWhite.png'):require('../assets/iconi.png') } style={{width:20,height:20,marginRight:0,marginLeft:4,}}></Image>}
        <View>
            <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize,fontWeight: 'bold',textAlign: "left",marginLeft:5}}>{this.props.title}</Text>
            {(this.props.miniLine==true && this.props.subTitle!=undefined) && <Text style={{marginRight:4, marginLeft:4,  color: style.textInputColor,fontSize: style.textInputFontSize*0.8,textAlign: "justify",marginTop:-2}}>{this.props.subTitle}</Text>}
        </View>
      </View>

      {this.props.miniLine!=true && <Text style={{marginRight:4, marginLeft:4, marginBottom:4, color: style.textInputColor,fontSize: style.textInputFontSize*0.8,textAlign: "justify",marginTop:5}}>{this.props.subTitle}</Text>}


              
        </View>


    </View>
    }</StyleContext.Consumer>
    	)}

    }

